import { PayloadAction } from '@reduxjs/toolkit';
import { Guid } from 'Lib/Guid';

export enum WorkflowType {
  Worksheet,
  WetMassEntry,
  DryMassEntry,
  MoistureTinRegistration,
  Invalid,
}

type Severity = 'info' | 'success' | 'error' | 'warning' | undefined;

type Message = {
  Id: string;
  MessageType: Severity;
  PropertyName: string;
  Text: string;
};

type TareId = {
  id: Guid;
  path: string;
  value?: string;
};

type BarcodeState = {
  barcode?: string;
  activeWorkflow?: ActiveWorkflow | null;
  responseMessage?: Message | null;
  isSyncing?: boolean;
  isListeningForWedgeScan?: boolean;
  isBarcodePanelOpen?: boolean;
  focusedRowUUID?: Guid | null;
  focusedTareId?: Guid | null;
  tareIdList: Array<TareId>;
};

type ActiveWorkflow = {
  ResourceId?: Guid | null;
  WorksheetId?: Guid | null;
  WorkflowType?: WorkflowType;
};

type InitAction = PayloadAction<Pick<BarcodeState, 'barcode' | 'activeWorkflow' | 'isSyncing'>>;
type PostBarcode = PayloadAction<{ barcode: string; concat?: boolean }>;
type PostBarcodeResolve = PayloadAction<{
  ActiveWorkflow?: ActiveWorkflow;
  ResponseMessage?: Message;
  FocusTareId?: Guid | null;
}>;
type PostBarcodeReject = PayloadAction<{}>;
type SetBarcodeStatus = PayloadAction<{ isListeningForWedgeScan?: boolean; isBarcodePanelOpen?: boolean }>;
type InitTareIdAction = PayloadAction<{ tareId: TareId; index?: number }>;

export type {
  BarcodeState,
  InitAction,
  InitTareIdAction,
  PostBarcode,
  PostBarcodeReject,
  PostBarcodeResolve,
  SetBarcodeStatus,
  TareId,
};
